<script>
	import Scrolly from "./components/Scrolly.svelte";
	import Map from "./components/Map.svelte";
  
	let value;
	const steps = [
	  "<p>Step 1</p>",
	  "<p>Step 2</p>",
	  "<p>Step 3</p><p>info</p>",
	  "<p>Step 4</p>",
	  "<p>Step 5</p>",
	  "<p>Step 6</p>",
	];
  
	let width;
  </script>
  <div class="app-wrapper" bind:clientWidth={width}>
  
  <section>
	<div class="section-container">
	  <div class="steps-container">
		<Scrolly bind:value>
		  {#each steps as text, i}
			<div class="step" class:active={value === i}>
			  <div class="step-content">{@html text}</div>
			</div>
		  {/each}
		  <div class="spacer" />
		</Scrolly>
	  </div>
	  <div class="sticky">
		<!-- <Scatterplot step={value} /> -->
		<Map step={value} />
	  </div>
	</div>
  </section>
  </div>
  <style>
	:global(body) {
	  overflow-x: hidden;
	}
  
	.app-wrapper{
	  width:100%;
	  margin:0;
	}
	.spacer {
	  height: 40vh;
	}
  
	.sticky {
	  position: sticky;
	  top: 10%;
	  flex: 1 1 60%;
	  width: 60%;
	}
  
	.section-container {
	  margin-top: 1em;
	  text-align: center;
	  transition: background 100ms;
	  display: flex;
	}
  
	.step {
	  height: 80vh;
	  display: flex;
	  place-items: center;
	  justify-content: center;
	}
  
	.step-content {
	  font-size: 1rem;
	  background: whitesmoke;
	  color: #ccc;
	  border-radius: 5px;
	  padding: 0.5rem 1rem;
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  transition: background 500ms ease;
	  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
	  text-align: left;
	  width: 75%;
	  margin: auto;
	  max-width: 500px;
	}
  
	.step.active .step-content {
	  background: white;
	  color: black;
	}
  
	.steps-container,
	.sticky {
	  height: 100%;
	}
  
	.steps-container {
	  flex: 1 1 40%;
	  z-index: 10;
	}
  
	/* Comment out the following line to always make it 'text-on-top' */
	@media screen and (max-width: 768px) {
	  .section-container {
		flex-direction: column-reverse;
	  }
	  .sticky {
		width: 95%;
		margin: auto;
	  }
	}
  </style>
  